import { Form, Typography } from "antd"
import React, { useEffect, useState } from "react";
import { CreateField } from "./dynamicField";

export const Rules = ({basicInfo, setWidth, fieldType})=>{
   



    return(
        <React.Fragment>
            <Typography className='label'>
                <Typography.Title level={4}>{basicInfo?.label}</Typography.Title>
            </Typography>


            {basicInfo?.flow=="formBase"?
            
                "Form preview is not availble"
            :
                fieldType?.map((field)=>(
                    <Form>
                        <Form.Item>
                            {/* <label>{field?.label}</label> */}
                            <CreateField 
                                search={""}
                                sortType={false} 
                                fieldType={field?.fieldType} 
                                label={field?.label} 
                                preview={true}
                                minimalView={true}
                                options={field?.options}
                            />
                        </Form.Item>
                    </Form>
                ))
            }
            
            

        </React.Fragment>
    )
}